import type {SketchLineObject} from '../sketch/SketchLineObject';
import {hasRuntimeFlag} from './hasRuntimeFlag';

/**
 * 判断对象是否为草图直线对象。
 * @param value 待判断的 Three 对象。
 * @returns 当对象满足草图直线协议时返回 true。
 */
export function isSketchLineObject(value: unknown): value is SketchLineObject {
    return hasRuntimeFlag(value, 'isSketchLineObject');
}
